import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  alt?: boolean;
  className?: string;
  id?: string;
}
export function Section({
  children,
  alt = false,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`py-10 md:py-16 px-6 ${alt ? 'bg-bg-alt' : 'bg-bg'} ${className}`} data-id="element-136">
      <div className="max-w-[640px] mx-auto w-full" data-id="element-137">{children}</div>
    </section>;
}